// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pmqi7","name":"styles_name__aGC4c","phone":"styles_phone__2qn-u"};